const krunkScript = require("../libs/krunkScript.js").default;
const UTILS = require("../libs/utils.js");
const config = require("../config.js");
// id, manager, UTILS, COLORS, config, game, isYTMP
function Player(id, manager, game) {
  this.biggestY = 0;
  this.id = id;
  this.accid = 0;
  this.isPlayer = true;
  this.velocity = new game.THREE.Vector3(0, 0, 0);
  this.inputs = [];
  this.db = true;
  this.stateHistory = [];
  this.weaponMeshes = [];
  this.custVals = {};
  this.reloads = [];
  this.ammos = [];
  this.reserveAmmos = [];
  this.upgrades = [];
  this.tempEggs = [];
  this.tmpStats = {};
  this.sentTo = [];
  this.weaponGeos = {};
  this.objectiveScore = 0;
  this.scoreObjs = {};
  this.checkPoint = null;
  this.checkPointData = [];
  this.checkPointList = [];
  this.convs = 0;
  this.legMeshes = [];
  this.shoeMeshes = [];
  this.armMeshes = [];
  this.mergedArmMeshes = [];
  this.wristMeshes = [];
  this.lastInput = {};
  this.lastDeltas = [];
  this.trade = null;
  this.ping = 0;
  this.pings = [];
  this.avgSpn = 0;
  this.score = 0;
  this.rounds = 0;
  this.compScore = 0;
  this.weaponStreak = 0;
  this.currentStreakWeapon = null;
  this.deaths = 0;
  this.timer = null;
  this.gameTimer = null;
  this.pickups = 0;
  this.aiKills = 0;
  this.kills = 0;
  this.killsC = 0;
  this.sussKills = 0;
  this.totShots = 0;
  this.hitShots = 0;
  this.totShotsL = 0;
  this.hitShotsL = 0;
  this.killsL = 0;
  this.deathsL = 0;
  this.scoreL = 0;
  this.weaponStats = {};
  this.driftkills = 0;
  this.closecalls = 0;
  this.classScores = {};
  this.firstblood = 0;
  this.assists = 0;
  this.nukes = 0;
  this.headshots = 0;
  this.legshots = 0;
  this.quickscopes = 0;
  this.noscopes = 0;
  this.airKills = 0;
  this.turboKills = 0;
  this.killMlt = 0;
  this.melees = 0;
  this.wallbangs = 0;
  this.longshots = 0;
  this.tKnifeKills = 0;
  this.fistKills = 0;
  this.revengeKills = 0;
  this.setbacks = 0;
  this.confirms = 0;
  this.deposits = 0;
  this.dogTags = 0;
  this.diffuses = 0;
  this.airDropCnt = 0;
  this.denies = 0;
  this.caps = 0;
  this.deathStreak = 0;
  this.highestStreak = 0;
  this.level = 0;
  this.lives = game.waitTimers && game.config ? game.config.lives || game.mode.lives || 0 : 0;
  this.deltaAdd = 0;
  this.deltaDiv = 1;
  this.sprayIndex = 0;
  this.flagIndex = -1;
  this.badgeIndex = -1;
  this.meleeIndex = -1;
  this.skinColIndex = -1;
  this.hairCol = -1;
  this.chatCol = -1;
  this.attachIndex = 0;
  this.faceIndex = -1;
  this.shoeIndex = -1;
  this.hatIndex = -1;
  this.headIndex = -1;
  this.playerCardIndex = -1;
  this.petIndex = -1;
  this.wristIndex = -1;
  this.backIndex = -1;
  this.bodyIndex = -1;
  this.waistIndex = -1;
  this.charms = [];
  this.dyeIndex = -1;
  this.pcStatIndex = -1;
  this.lastSpray = 0;
  this.lastInteract = 0;
  this.lastTerInteract = 0;
  this.lastPicked = {};
  this.medals = {};
  this.playTime = 0;
  this.playTimeUpdated = false;
  this.gameTime = 0;
  this.coverDis = 0;
  this.lastTimer = null;
  this.timeLog = 0;
  this.streaks = {};
  this.deathInfo = {};
  this.coughTimer = 0;
  this.noclip = false;
  this.speedBoost = 0;
  this.debugMode = false;
  this.unlimitedAmmo = false;
  this.unlimitedSprays = false;
  this.home = {};
  this.lastLoadout = [];
  this.lastSkins = [];
  this.lastThrow = true;
  this.lastThrowTime = 0;
  this.weaponTier = 0;
  this.inputLock = false;
  this.assetTxt = "";
  this.godMode = false;
  this.kicked = false;
  this.banned = false;
  this.smite = false;
  this.kickedByVote = false;
  this.dmgDealt = 0;
  this.mSent = 0;
  this.didAct = false;
  this.countedPlay = false;
  this.spawned = false;
  this.alias = null;
  this.clanKillsP = 0;
  this.clanDeathsP = 0;
  this.fakeName = null;
  this.fakeLevel = 1;
  this.waitRew = false;
  this.pendingTrigger = null;
  this.pendingSpin = null;
  this.buildHelper = null;
  this.buildHelperN = null;
  this.collidingObjs = [];
  this.custSync = [];
  this.effects = {};
  this.perks = [];
  this.attributes = {};
  this.additionalReward = 0;
  this.spraysPlaced = 0;
  this.config = {};
  this.showBadges = {
    verified: true,
    premium: true,
    partner: true,
    custom: true
  };
  this.challengeProg = [];
  this.streakIndexs = [];
  this.maxPossibleStreak = 0;
  this.isJuggernaut = false;
  this.isBusy = false;
  this.headMlt = 1;
  this.customLoadout = null;
  this.uniqueWeaponKills = [];
  this.didStarterScore = false;
  this.tmpPos = new game.THREE.Vector3();
  this.lastInteractData = {
    id: -1,
    type: -1
  };
  this.sharedBoxes = 0;
  this.sharingIsCaring = false;
  this.killedBy = [];
  this.noRecoil = false;
  this.spreadMlt = 1;
  this.dmgMlt = 1;
  this.speedMlt = 1;
  this.rangeMlt = 1;
  this.healthMlt = 1;
  var v9749;
  var v9750;
  var v9751;
  var vA540 = [];
  var vA541 = [];
  var vO309 = {};
  Object.defineProperty(this, "inventory", {
    get() {
      return this._inventory;
    },
    set(p12347) {
      this._inventory = p12347;
    }
  });
  Object.defineProperty(this, "team", {
    get() {
      if (this.forcePVP) {
        return undefined;
      } else {
        return this._team;
      }
    },
    set(p12348) {
      this._team = p12348;
    }
  });
  Object.defineProperty(this, "currentSkin", {
    get() {
      var v9752 = game.players.getWeapon(this, this.loadoutIndex);
      var v9753 = game.store.skins[v9752.melee ? this.meleeIndex : this.getSkinForLoadout(this.loadoutIndex)];
      if (v9752.upgraded) {
        v9753 = null;
      }
      if (!v9752.melee && v9753 && v9753.weapon - 1 != this.loadout[this.loadoutIndex]) {
        return vO309;
      } else {
        return v9753 || vO309;
      }
    }
  });
  Object.defineProperty(this, "currentMelee", {
    get() {
      return game.store.skins[this.meleeIndex] || vO309;
    }
  });
  Object.defineProperty(this, "currentShoes", {
    get() {
      return game.store.skins[this.shoeIndex] || vO309;
    }
  });
  Object.defineProperty(this, "currentBack", {
    get() {
      return game.store.skins[this.backIndex] || vO309;
    }
  });
  Object.defineProperty(this, "currentBody", {
    get() {
      return game.store.skins[this.bodyIndex] || vO309;
    }
  });
  Object.defineProperty(this, "currentDye", {
    get() {
      return game.store.skins[this.dyeIndex] || vO309;
    }
  });
  Object.defineProperty(this, "renderYou", {
    get() {
      return this.isYou && game.controls.camType.isNormal;
    }
  });
  Object.defineProperty(this, "hitboxPadW", {
    get() {
      return game.config.hitBoxPad + (this.config ? this.config.hbS || 0 : 0);
    }
  });
  Object.defineProperty(this, "hitboxPadH", {
    get() {
      return game.config.hitBoxPad + (this.config ? this.config.hbH || 0 : 0);
    }
  });
  Object.defineProperty(this, "currentWeaponId", {
    get() {
      if (this.loadout[this.loadoutIndex] == null) {
        return -1;
      } else {
        return this.loadout[this.loadoutIndex];
      }
    }
  });
  Object.defineProperty(this, "weaponLimit", {
    get() {
      if (this.perks.includes(6)) {
        return 3;
      } else {
        return 2;
      }
    }
  });
  this.init = function (z, x, y, name, isYou, isHacker) {
    this.active = true;
    this.isYou = isYou;
    if (isYou) {
      if (game.isServer) window.sandboxPlayer = this;
      else window.player = this;
    }
    this.sfres = !isYou && this.id !== -1;
    this.isHacker = isHacker;
    this.y = y;
    this.z = z;
    this.x = x;
    this.stepSrc = null;
    this.name = name || "unknown";
    this.velocity.set(0, 0, 0);
    this.xVelC = 0;
    this.zVelC = 0;
    this.tmpVel = {
      x: 0,
      y: 0,
      z: 0
    };
    this.walJum = 0;
    this.lastInObj = 0;
    this.renderMinimal = false;
    this.spread = 0;
    this.lastSpinD = 0;
    this.stateHistory.length = 0;
    this.xDire = 0;
    this.yDire = 0;
    this.xDirChase = null;
    this.yDirChase = null;
    this.camChase = null;
    this.height = config.playerHeight;
    this.adjustedHeight = config.playerHeight;
    this.headScale = config.cameraHeight;
    this.scale = config.playerScale;
    this.aimTime = 0;
    this.spreadPlus = 0;
    this.aimVal = 1;
    this.aimDir = 0;
    this.buildIndex = 0;
    this.latestData = false;
    this.interpolate = false;
    this.posBuffer = [];
    this.interpFram = 0;
    this.inputSTime = 0;
    this.inputSTPrg = 0;
    this.stepVal = 0;
    this.stepChase = 0;
    this.stepDir = 1;
    this.crouchVal = 0;
    this.rampFix = null;
    this.didJump = false;
    this.didJumpW = false;
    this.wallJumpC = 0;
    this.onGround = true;
    this.onGroundFrames = 0;
    this.lastGround = {};
    this.onPad = true;
    this.onLadder = false;
    this.onWall = 0;
    this.jumpCooldown = 0;
    this.spinDis = 0;
    this.locked = false;
    this.inputSN = 0;
    this.inputs.length = 0;
    this.inputFreq = 0;
    this.grapple = null;
    this.streak = 0;
    this.killStreak = 0;
    this.realKillStreak = 0;
    this.weaponStreak = 0;
    this.currentStreakWeapon = null;
    this.lastKill = 0;
    this.dmgReceived = {};
    this.burstCount = 0;
    this.didShoot = false;
    this.canThrow = !game || !game.mode || !game.mode.noKnives;
    this.airTime = 0;
    this.loadoutIndex = 0;
    this.swapTime = 0;
    this.customLoadout = null;
    this.lastPicked = {};
    this.propID = 1;
    this.weaponTier = 0;
    this.inView = false;
    this.lastLoadout.length = 0;
    this.lastSkins.length = 0;
    this.lastThrow = true;
    this.shotCntP = 0;
    this.noPVP = false;
    this.forcePVP = false;
    this.dogTags = 0;
    this.hitTimer = 0;
    this.ticker = 0;
    this.tickerC = 0;
    this.noMovTimer = 0;
    this.noMovT = 0;
    this.slideTimer = 0;
    this.driftTimer = 0;
    this.canSlide = true;
    this.canSlideT = 0;
    this.effectTimer = 0;
    this.isKranked = false;
    this.krankedTimer = 0;
    this.swapTweenA = 0;
    this.lastInput = {};
    this.landBobY = 0;
    this.landBobYR = 0;
    this.jumpBobY = 0;
    this.leanAnimX = 0;
    this.bobAnimZ = 0;
    this.leanAnimY = 0;
    this.leanAnimZ = 0;
    this.bobAnimY = 0;
    this.idleAnim = 0;
    this.inspecting = false;
    this.inspectAn = {};
    this.inspectX = false;
    this.reward = 0;
    this.recoilAnim = 0;
    this.recoilAnimY = 0;
    this.recoilForce = 0;
    this.stepDirR = 1;
    this.slideLegV = 0;
    this.recoilTweenY = 0;
    this.recoilTweenR = 0;
    this.recoilTweenYM = 0;
    this.recoilTweenZ = 0;
    this.jumpRot = 0;
    this.jumpRotM = 0;
    this.recoilX = 0;
    this.recoilZ = 0;
    this.lodActive = false;
    this.specStream = null;
    this.interProg = 0;
    this.interMProg = 0;
    this.chargeTime = 0;
    this.fullCharge = false;
    this.overCharged = false;
    this.throwCharge = 0;
    this.interTick = 0;
    this.lastProg = 0;
    this.lastMProg = 0;
    this.makingProg = false;
    this.makingMProg = false;
    this.doingInter = false;
    this.sentTo.length = 0;
    this.deltaAdd = 0;
    this.recon = false;
    this.meleeAnim = {};
    this.isHidden = false;
    this.inView = false;
    this.kpdData = false;
    this.bypassUser = false;
    this.resetTimer = 0;
    this.overlayInfo = null;
    this.collidingObjs.length = 0;
    this.onZone = null;
    this.defaultMovement = true;
    this.defaultVelocity = true;
    this.defaultRotation = true;
    this.disabledInputs = {};
    this.drunkCnt = 0;
    this.effects = {};
    this.attributes = {};
    this.attributeTimers = [];
    for (var vLN01561 = 0; vLN01561 < game.effectConfig.length; vLN01561++) {
      this.attributes[game.effectConfig[vLN01561].key] = game.effectConfig[vLN01561].def;
      this.attributeTimers[vLN01561] = [];
    }
    this.propSwitches = 0;
    this.propRotSaved = null;
    this.propRot = false;
    this.custSync.length = 0;
    this.isBusy = false;
    this.isJuggernaut = false;
    this.zappedBy = null;
    this.perks = [];
    this.lastInteractData.id = -1;
    this.lastInteractData.type = -1;
    this.sharedBoxes = 0;
    this.sharingIsCaring = false;
    this.totShotsL = 0;
    this.hitShotsL = 0;
    this.killsL = 0;
    this.deathsL = 0;
    this.scoreL = 0;
  };
  this.setInitPos = function () {
    if (!this.initPos) {
      this.initPos = {
        x: this.x,
        y: this.y,
        z: this.z
      };
    }
  };
  this.getName = function (p12355, p12356, p12357) {
    if (p12357 || !this.account) {
      return this.name;
    } else if (this.kpdData) {
      return "Officer Buddy";
    } else if (p12355) {
      if (this.fakeName) {
        return this.fakeName;
      } else if (p12356 && this.account && this.account.premiumT > 0 && this.showBadges.premium) {
        return this.account.alias;
      } else {
        return this.name;
      }
    } else {
      return "Player_" + this.sid;
    }
  };
  this.getSkinForLoadout = p12358 => {
    if (!this || !this.skins || !this.skins.length) {
      return -1;
    }
    var v9754;
    var v9755 = this.loadout[p12358];
    for (var vLN01562 = 0; vLN01562 < this.skins.length; vLN01562++) {
      v9754 = game.store.skins[this.skins[vLN01562]];
      if (v9754 && v9754.weapon - 1 == v9755) {
        return this.skins[vLN01562];
      }
    }
    return -1;
  };
  this.updateItems = function (p12359, p12360, p12361, p12362, p12363, p12364) {
    if (p12360) {
      if (p12361) {
        this.setClass(p12359, this.classIndex, this.secIndex, !!p12364 || !p12360);
        manager.resetMovVals(this);
        manager.swapWeapon(this, 0, true);
      }
      p12359.broadcast("rg", this.sid, p12361, [this.skins, this.faceIndex, this.shoeIndex, this.hatIndex, this.headIndex, this.bodyIndex, this.backIndex, this.waistIndex, this.meleeIndex, this.skinColIndex, this.hairCol, this.dyeIndex, this.pcStatIndex, this.attachIndex, this.secIndex, this.classIndex, this.petIndex, this.wristIndex, this.playerCardIndex]);
    } else {
      this.skins = p12362[0];
      this.faceIndex = p12362[1];
      this.shoeIndex = p12362[2];
      this.hatIndex = p12362[3];
      this.headIndex = p12362[4];
      this.bodyIndex = p12362[5];
      this.backIndex = p12362[6];
      this.waistIndex = p12362[7];
      this.meleeIndex = p12362[8];
      this.skinColIndex = p12362[9];
      this.hairCol = p12362[10];
      this.dyeIndex = p12362[11];
      this.pcStatIndex = p12362[12];
      this.attachIndex = p12362[13];
      this.secIndex = p12362[14];
      this.classIndex = p12362[15];
      this.petIndex = p12362[16];
      this.wristIndex = p12362[17];
      this.playerCardIndex = p12362[18];
      if (p12361) {
        this.renderYou = this.isYou && p12359.controls.camType.isNormal;
        this.setClass(p12359, this.classIndex, this.secIndex, !p12360);
        manager.resetMovVals(this);
        manager.swapWeapon(this, 0, true);
        if (this.isYou) {
          window.updateCamMouse(this.classIndex);
        }
      }
    }
    if (p12363 && this.active) {
      manager.regenMeshes(this);
    }
  };
  this.updateLoadout = function (game, p12366, p12367 = true, p12368, p12369, p12370, p12371, p12372) {
    var [v9756, v9757, v9758, v9759] = p12368;
    this.loadoutIndex = p12366;
    this.reloads.length = 0;
    this.ammos.length = 0;
    this.reserveAmmos.length = 0;
    this.upgrades.length = 0;
    this.loadout = [v9756];
    this.lastThrow = true;
    if (UTILS.isNumber(v9757)) {
      this.loadout.push(v9757);
    }
    if (UTILS.isNumber(v9757)) {
      this.secIndex = v9757;
    }
    if (UTILS.isNumber(v9758)) {
      this.loadout.push(v9758);
    }
    if (UTILS.isNumber(v9759)) {
      this.loadout.push(v9759);
    }
    if (!!(this.loadout.indexOf(12) < 0) && !p12372 && (!game.mode || !game.mode.noMelee)) {
      this.loadout.push(12);
    }
    var v9760;
    for (var vLN01563 = 0; vLN01563 < this.loadout.length; ++vLN01563) {
      v9760 = game.players.getWeapon(this, vLN01563);
      this.reloads.push(0);
      var v9761 = v9760.ammo != null && game.mode && game.mode.ammoLimit != null ? game.mode.ammoLimit : v9760.ammo;
      this.ammos.push(p12369 && UTILS.isNumber(p12369[vLN01563]) ? p12369[vLN01563] : v9761);
      this.reserveAmmos.push(p12370 && UTILS.isNumber(p12370[vLN01563]) ? p12370[vLN01563] : v9761 * game.getReserveMags(v9760));
      if (p12371) {
        this.upgrades.push(~~!!p12371[vLN01563]);
      }
    }
    this.customLoadout = [...this.loadout];
    if (p12367 && this.active) {
      manager.regenMeshes(this);
    }
  };
  this.refillKnife = function () {
    this.lastThrow = true;
    this.canThrow = true;
    if (this.isYou) {
      var v9762;
      for (var vLN01564 = 0; vLN01564 < this.ammos.length; ++vLN01564) {
        v9762 = game.players.getWeapon(this, vLN01564);
        if (v9762.melee) {
          var v9763 = document.getElementById("weapIconMel");
          var v9764 = UTILS.assetsUrl((this.canThrow && v9762.melee ? "/textures/melee/icon_" + (game.store.skins[this.meleeIndex] ? game.store.skins[this.meleeIndex].id || 0 : 0) : "/textures/weapons/" + v9762.icon) + ".png");
          if (v9762.assetIcon.length) {
            v9764 = UTILS.userAssetsUrl("/" + v9762.assetIcon.replace(/[^\d]/g, "") + "/texture.png");
          }
          if (v9763) {
            v9763.src = v9764;
          }
          break;
        }
      }
    }
  };
  this.hasEquipment = function () {
    var v9765;
    for (var vLN01565 = 0; vLN01565 < this.loadout.length; vLN01565++) {
      v9765 = game.weaponConfig[this.loadout[vLN01565]];
      if (v9765 && v9765.equipment) {
        return true;
      }
    }
    return false;
  };
  this.canUpgrade = function () {
    return !this.upgrades[this.loadoutIndex] && game.weaponConfig[this.loadout[this.loadoutIndex]] && game.weaponConfig[this.loadout[this.loadoutIndex]].canUpgrade && !this.hasEquipment();
  };
  this.setClass = function (p12373, p12374, p12375, p12376) {
    if (this.isBot && p12373 && p12373.mode && p12373.mode.botBypassClass) {
      p12376 = true;
    }
    if (!p12376) {
      if (p12373.config && p12373.config.classes.indexOf(p12374) < 0) {
        if (p12374 != p12373.config.classes[0]) {
          this.skins = [-1, -1];
        }
        p12374 = p12373.config.classes[0];
      }
      if (p12373.mode && p12373.config.forceC) {
        if (p12373.mode.noWeap) {
          p12374 = 9;
        }
        if (p12373.mode.forceClass != null) {
          p12374 = p12373.mode.forceClass;
        }
        if (p12373.mode.teamClass && p12373.mode.teamClass[this.team]) {
          p12374 = p12373.mode.teamClass[this.team];
          this.skins = [-1, -1];
        }
      }
    }
    if (p12374 == null || p12374 == null) {
      p12374 = p12373.classConfig.length - 1;
    }
    this.classIndex = p12374;
    this.config = p12373.classConfig[this.classIndex] || {
      loadout: [1]
    };
    this.loadout = [this.config.loadout[0]];
    if (!p12373.config || !p12373.config.noSecondary) {
      if (this.config.secondary) {
        if (UTILS.isNumber(p12375)) {
          this.loadout.push(p12375);
        }
      } else {
        this.secIndex = null;
      }
    }
    if (this.loadout.indexOf(12) < 0 && (!p12373.mode || !p12373.mode.noMelee)) {
      this.loadout.push(12);
    }
    this.speed = this.config.speed || 1;
    this.resetAmmo();
    this.regenDelay = this.config.regenDelay || config.regenDelay;
    this.maxHealth = p12373.mode && p12373.mode.maxHealth ? p12373.mode.maxHealth : this.config.health * (p12373.config ? p12373.config.healthMlt || 1 : 1) * (this.healthMlt ? this.healthMlt || 1 : 1);
    this.throwCharge = this.config.throwChrg || config.throwCharge;
    this.meleeLeap = this.config.leap || 0;
    this.wallJump = p12373.mode && p12373.mode.wallJ != null ? p12373.mode.wallJ : this.config.wallJ || 0;
    this.wallJumpMax = p12373.mode && p12373.mode.wallJM != null ? p12373.mode.wallJM : this.config.wallJM || 0;
    this.health = this.maxHealth;
    this.startHealth = this.health;
    this.hpChase = 1;
    this.regen = (p12373.mode && p12373.mode.noRegen || !p12373.config || !p12373.config.hpRegen ? 0 : this.config.regen || config.regenVal) * (p12373.mode && p12373.mode.regenMlt ? p12373.mode.regenMlt : 1) * (p12373.isSandbox && !this.isBot ? 3 : 1);
  };
  this.resetAmmo = function (p12377, p12378) {
    var vA542 = [...this.reloads];
    var vA543 = [...this.ammos];
    var vA544 = [...this.reserveAmmos];
    this.reloads.length = 0;
    this.ammos.length = 0;
    this.reserveAmmos.length = 0;
    this.reloadTimer = 0;
    this.cantShootTimer = 0;
    var v9766;
    for (var vLN01566 = 0; vLN01566 < this.loadout.length; ++vLN01566) {
      v9766 = game.players.getWeapon(this, vLN01566);
      if (v9766.noReload && p12378) {
        this.reloads.push(vA542[vLN01566]);
        this.ammos.push(vA543[vLN01566]);
        this.reserveAmmos.push(vA544[vLN01566]);
      } else {
        this.reloads.push(0);
        var v9767 = v9766.ammo != null && game.mode && game.mode.ammoLimit != null ? game.mode.ammoLimit : v9766.ammo;
        this.ammos.push(v9767);
        this.reserveAmmos.push(v9767 * game.getReserveMags(v9766));
      }
    }
    if (p12377 && this.isYou) {
      manager.updatePlayerAmmo(this);
      manager.resetReloadUIAnim(this);
    }
  };
  this.resetPosition = function (p12379, p12380, p12381, p12382) {
    this.z = p12381;
    this.x = p12379;
    this.y = p12380 + 0.01;
    this.xDire = p12382;
    this.velocity.y = 0;
    this.velocity.x = 0;
    this.velocity.z = 0;
    manager.setOnGround(this);
    this.noPVP = false;
    this.forcePVP = false;
    this.onLadder = false;
    this.onTerrain = false;
    this.onWall = false;
    this.didJump = false;
    this.didJumpW = false;
    this.onPad = false;
    this.crouchVal = 0;
    this.resetAmmo(true);
    manager.resetMovVals(this);
  };
  this.update = function (delta, p12384) {
    if (this.active) {
      if (this.inputs.length) {
        for (var vLN01567 = 0; vLN01567 < this.inputs.length; ++vLN01567) {
          this.procInputs(this.inputs[vLN01567], delta, false, !delta || delta.moveLock);
        }
        this.resetInputs();
      }
      this.idleAnim += config.idleAnimS * p12384;
      if (this.hpChase > this.health / this.maxHealth) {
        this.hpChase -= p12384 * 0.0002;
        if (this.hpChase <= 0) {
          this.hpChase = 0;
        }
      } else {
        this.hpChase = this.health / this.maxHealth;
      }
      if (this.interpolate) {
        var v9768 = null;
        var v9769 = null;
        var v9770 = null;
        for (var v9771 = delta.now - 1000 / this.sendRateA; this.posBuffer.length >= 2 && this.posBuffer[1].t <= v9771;) {
          this.posBuffer.shift();
        }
        if (this.posBuffer.length >= 2 && this.posBuffer[0].t <= v9771 && v9771 <= this.posBuffer[1].t) {
          v9768 = (v9771 - this.posBuffer[0].t) / (this.posBuffer[1].t - this.posBuffer[0].t);
          v9769 = this.posBuffer[0];
          v9770 = this.posBuffer[1];
        }
        if (v9768 != null) {
          this.oldX = this.x;
          this.oldY = this.y;
          this.oldZ = this.z;
          this.x = v9769.x + (v9770.x - v9769.x) * v9768;
          this.y = v9769.y + (v9770.y - v9769.y) * v9768;
          this.z = v9769.z + (v9770.z - v9769.z) * v9768;
          this.xDire = Math.lerpAngle(v9770.xD, v9769.xD, v9768);
          this.yDire = Math.lerpAngle(v9770.yD, v9769.yD, v9768);
          this.stepVal = v9769.s + (v9770.s - v9769.s) * v9768;
          if (!this.posStep && this.stepVal > 0) {
            this.posStep = true;
            manager.playerStep(this, 0, 0, true);
          } else if (this.posStep && this.stepVal < 0) {
            this.posStep = false;
            manager.playerStep(this, 0, 0, true);
          }
        }
      }
      if (this.interpolate || this.isYou) {
        var v9772 = UTILS.getD3D(this.oldX, this.oldY, this.oldZ, this.x, this.y, this.z);
        manager.playClip(this, this.crouchVal ? "Crouch" : v9772 > 0.1 ? "Move" : "Idle");
      }
    }
  };
  this.collides = function (p12385, p12386) {
    v9751 = this.scale + (this.config ? this.config.hbS : 0);
    p12386 = p12386 || 0;
    if (p12385.collT == "cylinder") {
      if (this.y <= p12385.y + p12385.height && this.y + this.height >= p12385.y - p12385.height) {
        return UTILS.getDistance(this.x, this.z, p12385.x, p12385.z) <= p12385.width + v9751;
      } else {
        return undefined;
      }
    } else {
      return this.x - v9751 < p12385.x + (p12385.width + p12386) && this.x + v9751 > p12385.x - (p12385.width + p12386) && this.z - v9751 < p12385.z + (p12385.length + p12386) && this.z + v9751 > p12385.z - (p12385.length + p12386) && this.y <= p12385.y + (p12385.heightS || p12385.height) + (p12385.isBorder && (!game.config || !game.config.disableB) ? config.borderH : 0) && this.y + (this.config ? this.config.hbH : 0) + this.height >= p12385.y - (p12385.heightS || p12385.height);
    }
  };
  this.collidesE = function (p12387, p12388, p12389) {
    return this.x - p12388 <= p12387.x + (p12387.width + p12389) && this.x + p12388 >= p12387.x - (p12387.width + p12389) && this.z - p12388 <= p12387.z + (p12387.length + p12389) && this.z + p12388 >= p12387.z - (p12387.length + p12389) && this.y <= p12387.y + p12387.height + (p12387.isBorder && (!game.config || !game.config.disableB) ? config.borderH : 0) && this.y + (this.config ? this.config.hbH : 0) + this.height >= p12387.y - p12387.height;
  };
  this.collidesP = function (p12390) {
    if (p12390.interpolate) {
      return this.x - this.scale - (this.config ? this.config.hbS : 0) < p12390.x2 + p12390.scale && this.x + this.scale + (this.config ? this.config.hbS : 0) > p12390.x2 - p12390.scale && this.z - this.scale - (this.config ? this.config.hbS : 0) < p12390.z2 + p12390.scale && this.z + this.scale + (this.config ? this.config.hbS : 0) > p12390.z2 - p12390.scale && this.y <= p12390.y2 + p12390.height && this.y + (this.config ? this.config.hbH : 0) + this.height >= p12390.y2;
    } else {
      return this.x - this.scale - (this.config ? this.config.hbS : 0) < p12390.x.round(1) + p12390.scale && this.x + this.scale + (this.config ? this.config.hbS : 0) > p12390.x.round(1) - p12390.scale && this.z - this.scale - (this.config ? this.config.hbS : 0) < p12390.z.round(1) + p12390.scale && this.z + this.scale + (this.config ? this.config.hbS : 0) > p12390.z.round(1) - p12390.scale && this.y <= p12390.y.round(1) + p12390.height && this.y + (this.config ? this.config.hbH : 0) + this.height >= p12390.y.round(1);
    }
  };
  this.resetInputs = function () {
    this.inputs.length = 0;
  };
  this.reset = function () {
    this.checkPoint = null;
    this.checkPointList.length = 0;
    this.checkPointData.length = 0;
    this.lastPicked = {};
    this.weaponTier = 0;
    this.customLoadout = null;
    this.lastLoadout.length = 0;
    this.lastSkins.length = 0;
    this.lastThrow = true;
    this.medals = {};
    this.headMlt = 1;
    this.didStarterScore = false;
    this.killedBy = [];
  };
  this.resetMeleeAnim = function () {
    this.meleeAnim.weaR = 0;
    this.meleeAnim.weaM = 0;
    this.meleeAnim.armY = 0;
    this.meleeAnim.armR = 0;
    this.meleeAnim.lArm = 0;
    this.meleeAnim.rArm = 0;
    this.meleeAnim.flipW = 0;
    this.meleeAnim.armT = 0;
    this.meleeAnim.armM = 0;
    this.meleeAnim.armE = 0;
    this.meleeAnim.armS = 0;
  };
  var vLN01568 = 0.1;
  this.procInputs = function (input, game, recon, lock) {
    this.recon = recon;
    if (this.noclip) {
      this.onGround = true;
    }
    var v9773 = game.movement[this.config.movSch || 0];
    var v9774 = Math.max(vLN01568, Math.min(input[1], config.dltMx)) / this.deltaDiv;
    if (!v9774 || v9774 < vLN01568) {
      v9774 = vLN01568;
    }
    this.inputSN = input[0];
    var v9775 = (parseFloat(input[2] || 0) || 0) / 1000;
    if (this.config.lckCmYR) {
      v9775 = 0;
    }
    var v9776 = (parseFloat(input[3] || 0) || 0) / 1000;
    this.makingProg = false;
    this.makingMProg = false;
    manager.clearInteract(this);
    var v9777 = !!input[5];
    var v9778 = !!input[6];
    var v9779 = !!input[7];
    var v9780 = !!input[8];
    var v9781 = !!input[9];
    var v9782 = UTILS.isNumber(input[13]) ? input[13] : 0;
    var v9783 = !!input[14];
    var v9784 = UTILS.isNumber(input[11]) ? input[11] : 0;
    var v9785 = input[10];
    if (v9785 != 1 && v9785 != -1) {
      v9785 = 0;
    }
    var v9786 = config.movDirs[input[4]];
    if (v9786 != null) {
      v9786 += (this.config.movDrP || 0) * Math.PI;
    }
    if (game && game.mainScript) {
      if (game.mainScript.onPlayerUpdate) {
        game.mainScript.onPlayerUpdate(this.id + "", v9774, krunkScript.prefix({
          mouseY: v9775,
          mouseX: v9776,
          movDir: v9786,
          lMouse: v9777,
          rMouse: v9778,
          jump: v9779,
          reload: v9780,
          crouch: v9781,
          scroll: v9785,
          swap: v9784,
          restK: v9782,
          inter: v9783
        }));
      }
      if (this.disabledInputs.mouseY) {
        v9775 = 0;
      }
      if (this.disabledInputs.mouseX) {
        v9776 = 0;
      }
      if (this.disabledInputs.movDir) {
        v9786 = undefined;
      }
      if (this.disabledInputs.lMouse) {
        v9777 = false;
      }
      if (this.disabledInputs.rMouse) {
        v9778 = false;
      }
      if (this.disabledInputs.jump) {
        v9779 = false;
      }
      if (this.disabledInputs.reload) {
        v9780 = false;
      }
      if (this.disabledInputs.crouch) {
        v9781 = false;
      }
      if (this.disabledInputs.scroll) {
        v9785 = 0;
      }
      if (this.disabledInputs.swap) {
        v9784 = 0;
      }
      if (this.disabledInputs.restK) {
        v9782 = 0;
      }
      if (this.disabledInputs.inter) {
        v9783 = false;
      }
    }
    if (!game.noDefaultBehav) {
      if (input[15]) {
        var v9787 = input[15] || 0;
        if (!this.inputSTime || this.inputSTime < v9787) {
          this.inputSTime = v9787;
        }
      }
      if (input[16]) {
        this.inputSTPrg = input[16] || 0;
        this.inputSTPrg = Math.min(Math.max(0, this.inputSTPrg), 1.2);
      }
      var v9788 = UTILS.getAngleDst(v9776, this.xDire);
      this.spinDis += Math.abs(v9788);
      var v9789 = UTILS.getAngleDst(v9775, this.yDire);
      var v9790 = !recon && this.renderYou;
      if (v9790 && (this.leanAnimX -= v9788 * config.leanSens, this.leanAnimX = UTILS.limit(this.leanAnimX, config.leanMax), this.leanAnimY -= UTILS.getAngleDst(v9775, this.yDire) * config.leanSens, this.leanAnimY = UTILS.limit(this.leanAnimY, config.leanMax), this.leanAnimY && (this.leanAnimY *= Math.pow(config.leanPull, v9774)), this.leanAnimX && (this.leanAnimX *= Math.pow(config.leanPull, v9774)), this.leanAnimZ && (this.leanAnimZ *= Math.pow(config.leanPullZ, v9774)), this.bobAnimZ && (this.bobAnimZ *= Math.pow(config.bobPullZ, v9774)), this.bobAnimY && (this.bobAnimY *= Math.pow(config.bobPullY, v9774)), this.recoilX && (this.recoilX *= Math.pow(config.leanPull, v9774)), this.recoilZ && (this.recoilZ *= Math.pow(config.leanPull, v9774)), this.inspecting && this.weapon)) {
        var v9791 = this.weapon.insX || Math.PI / 2.8;
        if (this.inspectX < v9791) {
          this.inspectX += (v9791 - this.inspectX) * 0.1;
        }
      }
      if (this.defaultRotation) {
        if (v9773.dir) {
          v9773.dir(this, v9776.round(3), v9775.round(3), v9786, v9774, game, input);
        } else {
          game.movement[0].dir(this, v9776.round(3), v9775.round(3), v9786, v9774, game, input);
        }
      }
      if (!recon && this.config.shtDrg != 1) {
        if (this.xDirChase == null || this.yDirChase == null) {
          this.xDirChase = v9776;
          this.yDirChase = v9775;
        } else {
          var v9792 = Math.PI * 2;
          var v9793 = this.config.shtDrg * 0.003 * v9774;
          var v9794 = (this.xDirChase - v9776 + v9792) % v9792;
          var v9795 = Math.min(Math.abs(v9794 - v9792), v9794, v9793);
          var v9796 = v9794 - Math.PI >= 0 ? 1 : -1;
          this.xDirChase += v9796 * v9795 + v9792;
          this.xDirChase %= v9792;
          if (this.yDirChase < v9775) {
            this.yDirChase += v9793;
            if (this.yDirChase > v9775) {
              this.yDirChase = v9775;
            }
          } else if (this.yDirChase > v9775) {
            this.yDirChase -= v9793;
            if (this.yDirChase < v9775) {
              this.yDirChase = v9775;
            }
          }
        }
      }
      if (v9784 == 4) {
        manager.swapEquipment(this, recon);
      } else if (v9784 == 2) {
        manager.swapMelee(this, recon);
      } else if (v9784 == 1) {
        manager.swapSecondary(this, recon);
      } else if (v9784 == 3) {
        manager.swapWeapon(this, null, null, undefined, 0, recon);
      } else if (v9785) {
        manager.swapWeapon(this, v9785, false, undefined, undefined, recon);
      }
      if (!recon) {
        if (this.recoilForce) {
          this.recoilAnim += this.recoilForce * v9774;
          this.recoilAnimY += this.recoilForce * (this.weapon.recoilY || 1) * (1 - this.crouchVal * 0.3) * v9774;
          this.recoilForce *= Math.pow(this.weapon.recoverF, v9774);
        }
        if (this.recoilAnim) {
          this.recoilAnim *= Math.pow(this.weapon.recover, v9774);
        }
        if (this.recoilAnimY) {
          this.recoilAnimY *= Math.pow(this.weapon.recoverY || this.weapon.recover, v9774);
        }
      }
      this.oldX = this.x;
      this.oldY = this.y;
      this.oldZ = this.z;
      if (this.weapon.noAim && this.aimVal < 1) {
        if (this.isYou) {
          manager.toggleAim(this, 0);
        }
        this.aimVal = 1;
      } else if (this.weapon.zoom && (!game.mode.teamOptions || game.mode.teamOptions[this.team - 1] != "Prop") && (!this.weapon.noAim || this.swapTime > 0)) {
        var v9797 = this.reloadTimer <= 0 && this.swapTime <= 0 && (!this.weapon.melee || this.canThrow) && !v9773.noThrow && (game.config.throwMel || !this.weapon.melee);
        if (v9778 && this.aimVal > 0 && v9797) {
          manager.cancelInspect(this);
          this.aimDir = 0;
          this.aimVal -= 1 / (this.weapon.aimSpd / v9774);
          if (this.aimVal <= 0) {
            this.aimVal = 0;
            if (this.isYou && !recon) {
              manager.toggleAim(this, 1);
            }
          }
          if (this.isYou && !recon && (!this.weapon.scope || this.currentSkin.noScope)) {
            manager.updateAim(this, 1 - this.aimVal);
          }
        } else if (!v9797 || !v9778 && this.aimVal < 1) {
          this.aimDir = 1;
          if (!this.aimVal && this.isYou && !recon) {
            manager.toggleAim(this, 0);
          }
          this.aimVal += 1 / (this.weapon.aimSpd / v9774);
          if (this.aimVal >= 1) {
            this.aimVal = 1;
          }
          if (this.isYou && !recon && (!this.weapon.scope || this.currentSkin.noScope)) {
            manager.updateAim(this, 1 - this.aimVal);
          }
        }
        if (this.aimVal == 0) {
          this.aimTime += v9774;
        } else {
          this.aimTime = 0;
        }
      }
      if (!recon && game.config.chrgWeps) {
        var v9798 = this.weapon && this.weapon.shootChrg ? v9777 : this.aimVal < 1;
        var v9799 = this.weapon && this.weapon.chrgTime ? this.weapon.chrgTime : this.throwCharge;
        var v9800 = game && game.mode && game.mode.forceCharge;
        if (v9798 && !this.overCharged && this.swapTime <= 0 && (this.weapon && this.weapon.chrgTime && this.ammos[this.loadoutIndex] || this.canThrow && this.weapon.canThrow)) {
          if (v9800) {
            this.chargeTime = 0;
            this.fullCharge = true;
            this.overCharged = false;
          } else {
            this.chargeTime += this.chargeTime >= v9799 ? v9774 * 0.1 / (160 / (v9799 * (config.overCharge - 1))) : v9774;
            if (this.weapon.ovrChrg) {
              if (this.chargeTime >= v9799 * config.overCharge) {
                this.chargeTime = 0;
                this.fullCharge = false;
                this.overCharged = true;
              }
            } else if (this.chargeTime >= v9799) {
              this.fullCharge = true;
              this.chargeTime = v9799;
            }
            this.interMProg = this.chargeTime / v9799;
          }
        } else if (!v9800 && this.weapon.chrgDec && this.chargeTime > 0) {
          this.chargeTime -= this.weapon.chrgDec * v9774;
          this.fullCharge = false;
          if (this.chargeTime <= 0) {
            this.chargeTime = 0;
            if (this.aimVal == 1) {
              this.overCharged = false;
            }
          }
          this.interMProg = this.chargeTime / v9799;
        } else {
          this.fullCharge = false;
          this.chargeTime = 0;
          if (this.aimVal == 1) {
            this.overCharged = false;
          }
        }
        this.makingMProg = this.chargeTime > 0;
      }
      this.selectBuild = false;
      if (v9778 && this.weapon.build && (this.selectBuild = true, Math.abs(v9788) > 0.008 || Math.abs(v9789) > 0.008)) {
        var v9801 = UTILS.getDir(0, 0, v9788, v9789);
        v9801 += Math.PI;
        var v9802 = Math.PI * 2 / game.BUILD_OBJS.length;
        var v9803 = Math.floor(v9801 / v9802);
        if (v9803 >= game.BUILD_OBJS.length) {
          v9803 = 0;
        }
        if (this.buildIndex != v9803) {
          if (this.isYou && SOUND && !recon) {
            SOUND.play("tick_0", 0.2);
          }
          this.buildIndex = v9803;
        }
      }
      this.wasStopCrouch = game.config.headClipFix && this.stopCrouch;
      this.stopCrouch = false;
      if (this.defaultMovement && !this.wasStopCrouch) {
        if (!this.config.canCrch) {
          v9781 = false;
        }
        if (v9781 && this.crouchVal < 1 && !this.onLadder) {
          this.crouchVal += config.crouchSpd * v9774;
          if (this.crouchVal >= 1) {
            this.crouchVal = 1;
            if (manager.isServer) {
              game.incStat("crc", this);
            }
          }
          if (this.onGround || this.grapple) {
            if (v9790) {
              this.bobAnimY -= config.crouchAnim * 1.4 * v9774;
            }
          } else {
            this.y += config.crouchSpd * v9774;
          }
        } else if (!v9781 && this.crouchVal > 0) {
          this.crouchVal -= config.crouchSpd * v9774;
          if (this.crouchVal <= 0) {
            this.crouchVal = 0;
          }
          if (this.onGround || this.grapple) {
            if (v9790) {
              this.bobAnimY += config.crouchAnim * v9774;
            }
          } else {
            this.y -= config.crouchSpd * v9774;
          }
        }
        if (this.crouchVal) {
          this.crouchVal = this.crouchVal.round(3);
        }
      }
      manager.updateHeight(this);
      var v9804 = this.onGround || this.onLadder;
      if (!lock) {
        var v9805;
        v9805 = v9804 ? this.config.grA / 100 * this.speed * (game.mode.groundAccel == null ? 1 : game.mode.groundAccel) : this.config.arA / 100 * (game.mode.realMov ? 0.72 : 1) * (game.mode.groundAccel == null ? 1 : game.mode.groundAccel);
        v9805 *= this.aimVal ? 1 : config.aimSlow;
        v9805 *= game.mode.spdMlt ? game.mode.spdMlt[this.team] || 1 : 1;
        v9805 *= this.crouchVal ? this.config.crchSpd : 1;
        v9805 *= this.weapon.spdMlt * v9774;
        v9805 *= this.weapon.shootChrg && v9777 ? 0.35 : 1;
        var vLN01569 = 0;
        vLN01569 = this.onLadder ? config.ladderDecel : this.onTerrain ? config.terrainDecel : this.onGround ? this.config.grDec || config.groundDecel : v9773.airDecel || this.config.airDec || config.airDecel;
        if (this.canSlideT > 0) {
          this.canSlideT -= v9774;
          if (this.canSlideT <= 0) {
            this.canSlideT = 0;
          }
        }
        if (this.crouchVal <= 0.5) {
          this.canSlide = true;
        }
        if (!this.onGround || !this.crouchVal) {
          this.slideTimer = 0;
        }
        if (this.slideTimer) {
          this.slideTimer -= v9774;
          if (manager.isServer && this.perks.includes(5)) {
            this.driftTimer += v9774;
            if (this.driftTimer >= 750) {
              this.driftTimer = 0;
              game.explosion(this.x, this.y + this.height / 2, this.z, 50, 300, this, {
                aiOnly: 1,
                noHit: true
              });
            }
          }
          if (this.slideTimer <= 0) {
            this.slideTimer = 0;
          } else {
            v9805 *= 0.25;
            vLN01569 = this.onTerrain ? config.terrainSlideDecel : config.slideDecel;
            var v9813 = UTILS.getDistance(this.velocity.x, this.velocity.z, 0, 0);
            var v9807 = this.xDire;
            if ((this.config.frSlid || game.mode && game.mode.frSlid) && input[4] != -1) {
              v9807 -= Math.PI / 4 * (input[4] - 1);
            } else if (this.config.bkSlid && (input[4] == 4 || input[4] == 5 || input[4] == 6)) {
              v9807 += Math.PI;
            }
            var v9837 = UTILS.getDir(Math.sin(v9807), Math.cos(v9807), 0, 0);
            this.velocity.x = v9813 * Math.cos(v9837 + Math.PI);
            this.velocity.z = v9813 * Math.sin(v9837 + Math.PI);
          }
        }
        this.jumpCooldown = Math.max(this.jumpCooldown - v9774, 0);
        if (this.defaultMovement && this.jumpCooldown <= 0 && !this.config.disJump && (this.onGround || this.config && this.config.infJ)) {
          manager.tryJump(this, v9779);
        }
        var v9809 = game.mode.noWallJ ? 0 : game.config ? game.config.wallJP : 0;
        var v9810 = game.mode.wallJD == null ? this.config.wallJD || 0 : game.mode.wallJD;
        var v9811 = this.velocity.y < 0 && this.wallJump && this.onWall && v9809 > 0 && this.crouchVal ? v9810 : 1;
        if (!v9804) {
          this.velocity.y -= v9774 * (config.gravity * (game.config ? game.config.gravMlt : 1) * (game.mode.gravMlt == null ? 1 : game.mode.gravMlt)) * v9811;
        }
        var v9812 = UTILS.limitMM(1 - input[12], 0, 1);
        v9805 *= v9812;
        if (this.noclip) {
          v9805 *= 2;
        }
        if (this.speedBoost) {
          v9805 *= this.speedBoost;
        }
        v9805 *= this.attributes.speed;
        v9805 *= this.attributes.rooted;
        v9805 *= this.isKranked ? game.mode.bonuses.speed : 1;
        v9805 *= this.perks.includes(3) ? 1.15 : 1;
        v9805 *= this.speedMlt;
        if (this.defaultMovement) {
          if (v9773.mov) {
            v9773.mov(this, v9805, vLN01569, v9786, v9776, input, game, v9774);
          } else {
            game.movement[0].mov(this, v9805, vLN01569, v9786, v9776, input, game, v9774);
          }
        }
        if (!v9804) {
          if (this.xVelC) {
            this.velocity.x += this.xVelC * 0.07;
            this.xVelC = 0;
          }
          if (this.zVelC) {
            this.velocity.z += this.zVelC * 0.07;
            this.zVelC = 0;
          }
        }
        if (config.currentSeason >= 7 && !v9804 && v9788 && game.config.airStrf) {
          var v9813 = UTILS.getDistance(this.velocity.x, this.velocity.z, 0, 0);
          var v9814 = UTILS.getDir(0, 0, this.velocity.x, this.velocity.z) + v9788 * 1;
          if ((input[4] == 3 || input[4] == 2) && v9788 > 0 || (input[4] == 7 || input[4] == 0) && v9788 < 0) {
            this.velocity.x = v9813 * Math.cos(v9814 + Math.PI);
            this.velocity.z = v9813 * Math.sin(v9814 + Math.PI);
          }
        }
        if (this.defaultVelocity) {
          if (v9773.vel) {
            v9773.vel(this, vLN01569, v9774, game);
          } else {
            game.movement[0].vel(this, vLN01569, v9774, game);
          }
        }
        if (v9779) {
          manager.endGrapple(this);
        }
        if (this.grapple) {
          if (this.grapple.range > 35) {
            this.grapple.range -= v9774 * 0.04;
          }
          var v9852 = UTILS.getD3D(this.x, this.y, this.z, this.grapple.x, this.grapple.y, this.grapple.z);
          if (v9852 > this.grapple.range) {
            var v9816 = UTILS.getDrs(this, this.grapple);
            var v9817 = (v9816[0] || 0) + Math.PI / 2;
            var v9818 = v9816[1] || 0;
            var v9819 = this.grapple.x + this.grapple.range * Math.sin(v9817 + Math.PI / 2) * Math.cos(v9818);
            var v9820 = this.grapple.z + this.grapple.range * Math.cos(v9817 + Math.PI / 2) * Math.cos(v9818);
            var v9821 = this.grapple.y + this.grapple.range * Math.sin(v9818);
            var v9822 = Math.pow(vLN01569, v9774);
            this.velocity.x = (v9819 - this.oldX) * v9822 / v9774;
            this.velocity.y = (v9821 - this.oldY) * v9822 / v9774;
            this.velocity.z = (v9820 - this.oldZ) * v9822 / v9774;
            this.x = v9819;
            this.z = v9820;
            this.y = v9821;
          }
        }
        if (!recon) {
          if (this.velocity.x || this.velocity.y || this.velocity.z) {
            this.noMovT = 0;
          } else {
            this.noMovT += v9774;
          }
          var v9823 = game.mode.teamOptions && game.mode.teamOptions[this.team - 1] == "Stalker" && this.noMovT >= 300 || this.forceHide;
          if (this.isHidden != v9823) {
            this.isHidden = v9823;
            if (this.isYou) {
              hiddenMsg.style.display = this.isHidden ? "block" : "none";
            }
          }
        }
        if (v9777 && game.mode.teamOptions && game.mode.teamOptions[this.team - 1] == "Prop") {
          manager.pickProp(this);
        }
        if (!v9777 && !recon) {
          this.doingInter = false;
        }
        this.wasOnGround = this.onGround && !this.didJump;
        this.wasOnPad = this.onPad;
        var v9824 = false;
        var v9825 = null;
        this.onGround = this.noclip || false;
        this.onWall = 0;
        this.onLadder = false;
        this.noPVP = false;
        this.forcePVP = false;
        this.onPad = false;
        var v9826 = false;
        manager.playerCollision(this, recon);
        vA541.length = 0;
        v9750 = game.map.manager.getGridArrays(this.x, this.y, this.z);
        if (!this.noclip) {
          var v9827 = this.scale + (this.config ? this.config.hbS : 0);
          vA540.length = 0;
          var vLN01570 = 0;
          if (v9750) {
            for (var vLN01583 = 0; vLN01583 < v9750.length; ++vLN01583) {
              v9749 = v9750[vLN01583];
              vLN01570++;
              if (v9749.isTri) {
                var v9828 = game.COLLISIONS.capsuleColl(v9749, this.x, this.y, this.z, this.scale, this.height);
                if (v9828) {
                  var v9829 = !!(v9828.normal.y > 0.7);
                  if (v9829) {
                    manager.setOnGround(this);
                  }
                  this.velocity.addScaledVector(v9828.normal, -v9828.normal.dot(this.velocity));
                  var v9830 = v9828.normal.multiplyScalar(v9828.depth);
                  this.x += v9830.x;
                  this.y += v9830.y;
                  this.z += v9830.z;
                }
                continue;
              }
              if (v9749.tRadius && (v9749.perkMachine || v9749.krumMachine || v9749.mysteryBox || v9749.gate || v9749.bank || v9749.onInteractKey) && (v9749.active || !v9749.active && v9749.closeable) && this.collides(v9749, v9749.tRadius || 0) && game.teamCheck(v9749, this)) {
                if (!v9749.krumMachine || (this.upgrades[this.loadoutIndex] || !this.weapon.canUpgrade) && v9749.purchasedBy != this.id || this.hasEquipment() || v9749.state == 1 || v9749.purchasedBy != null && v9749.purchasedBy != this.id) {
                  if (v9749.perkMachine && !this.perks.includes(v9749.perk)) {
                    manager.changeInteract(this, v9749, 14);
                  } else if (!v9749.mysteryBox || this.hasEquipment() || v9749.state == 1 || v9749.pendingWeapon == -1 || v9749.purchasedBy != null && v9749.purchasedBy != -1 && v9749.purchasedBy != this.id) {
                    if (v9749.gate) {
                      manager.changeInteract(this, v9749, 0);
                    } else if (v9749.bank) {
                      manager.changeInteract(this, v9749, 1);
                    } else if (v9749.onInteractKey) {
                      manager.changeInteract(this, v9749, 7);
                    }
                  } else {
                    manager.changeInteract(this, v9749, 13);
                  }
                } else {
                  manager.changeInteract(this, v9749, 15);
                }
              }
              if (v9749.active && this.collidesE(v9749, v9827, config.collPad)) {
                if (game.saveColls && vA541.indexOf(v9749.sid) < 0) {
                  vA541.push(v9749.sid);
                }
                if ((v9749.onCollision || v9749.onHoldMouse || v9749.onEnterObject || v9749.onExitObject || v9749.jumpPad || v9749.ladder || v9749.ropeLadder || v9749.trigger || v9749.teleporter || v9749.checkpoint) && v9749.sid != null) {
                  if (vA540.indexOf(v9749.sid) >= 0) {
                    continue;
                  }
                  vA540.push(v9749.sid);
                }
                if (v9749.onCollision && game.now - (v9749.lastColT || 0) >= v9749.onColT) {
                  v9749.lastColT = game.now;
                  game.onTrigger(this, v9749);
                }
                if (v9749.perkMachine && !v9749.gotFreeP && this.crouchVal == 1) {
                  v9749.gotFreeP = true;
                  manager.score(this, 50);
                }
                if (v9749.onHoldMouse) {
                  manager.changeInteract(this, v9749, 4, null, 1);
                  if (v9777 && this.onGround) {
                    this.doingInter = true;
                    this.makingProg = true;
                    this.interProg += v9774 / v9749.onInteractT;
                    if (this.interProg >= 1) {
                      this.interProg = 0;
                      game.onTrigger(this, v9749);
                    }
                  }
                } else if (v9749.onEnterObject || v9749.onExitObject) {
                  var v9831 = false;
                  if (this.collidingObjs.indexOf(v9749.sid) < 0) {
                    this.collidingObjs.push(v9749.sid);
                    v9831 = true;
                  }
                  if (v9749.onEnterObject && v9831) {
                    game.onTrigger(this, v9749);
                  }
                } else if (v9749.isEvent) {
                  ;
                } else if (v9749.redirection) {
                  ;
                } else if (v9749.serverNode) {
                  ;
                } else if (v9749.jumpPad) {
                  var v9832 = v9749.bounce * 0.1 / (this.crouchVal == 1 && v9749.crouch ? 2 : 1);
                  var vLN01572 = 0;
                  var vLN01573 = 0;
                  if (v9749.dir == 0) {
                    vLN01573 = 0;
                  } else if (v9749.dir == 1) {
                    vLN01573 = 180;
                  } else if (v9749.dir == 4) {
                    vLN01573 = 90;
                  } else if (v9749.dir == 2) {
                    vLN01573 = -90;
                  } else if (v9749.dir == 5) {
                    vLN01572 = -90;
                  } else if (v9749.dir == 3) {
                    vLN01572 = 90;
                  }
                  var v9833 = !vLN01572 && !vLN01573 || vLN01573 == 180;
                  if (vLN01572) {
                    vLN01572 -= 90;
                  }
                  if (!v9833) {
                    vLN01572 = UTILS.toRad(vLN01572);
                    vLN01573 = UTILS.toRad(vLN01573);
                    var v9834 = v9832 * Math.sin(-vLN01573) * Math.cos(vLN01572);
                    var v9835 = v9832 * Math.cos(-vLN01573) * Math.cos(vLN01572);
                    if (v9834) {
                      this.velocity.x = v9834;
                    }
                    if (v9835) {
                      this.velocity.z = v9835;
                    }
                  } else {
                    this.velocity.y = v9832 * (vLN01573 == 180 ? -1 : 1);
                  }
                  this.onGround = false;
                  if (!recon && !!this.isYou && !this.wasOnPad) {
                    SOUND.play("bounce_0", 1, false, UTILS.randFloat(0.95, 1));
                  }
                  if (manager.isServer && !this.wasOnPad) {
                    game.challenges.update(game, "bst", 1, null, this);
                  }
                  this.onPad = true;
                } else if (v9749.score) {
                  if (!this.scoreObjs[v9749.sid]) {
                    this.scoreObjs[v9749.sid] = 1;
                    manager.score(this, v9749.scoreP);
                    manager.logTime(this);
                  }
                } else if (v9749.premium && (this.account && this.account.premiumT || this.premiumT)) {
                  ;
                } else if (v9749.verified && (this.account && this.account.featured || this.featured)) {
                  ;
                } else if (v9749.partner && (this.account && this.account.partnerApp >= 2 || this.partner >= 2)) {
                  ;
                } else if (v9749.kpd && this.account && this.account.canFlag) {
                  ;
                } else if (v9749.teamZ && game.teamCheck(v9749, this)) {
                  ;
                } else if (v9749.kr && manager.enoughKR(this, v9749.amount)) {
                  ;
                } else if (v9749.noPVP) {
                  this.noPVP = true;
                } else if (v9749.forcePVP) {
                  this.forcePVP = true;
                } else if (v9749.teleporter) {
                  game.checkTeleport(this, v9749);
                } else if (v9749.checkpoint) {
                  game.setCheckPoint(this, v9749);
                } else if (v9749.pickup != null && UTILS.isNumber(v9749.pickup) && (!game.mode.teamOptions || game.mode.teamOptions[this.team - 1] != "Infected")) {
                  ;
                } else if (v9749.flag) {
                  ;
                } else if (v9749.trigger) {
                  if (this.flag && !game.mode.oneflag && v9749.team == this.team && v9749.flagObj && (game.mode.rush || !v9749.flagObj.carrier) && v9749.flagObj.x == v9749.flagObj.orgX && v9749.flagObj.y == v9749.flagObj.orgY && v9749.flagObj.z == v9749.flagObj.orgZ) {
                    game.capFlag(this, this.flag);
                  }
                } else if (v9749.kill) {
                  if (this.flag) {
                    game.resetFlag(this.flag);
                    this.flag = null;
                  }
                  if (manager.isServer && !this.godMode) {
                    manager.kill(this);
                  }
                } else if (v9749.ladder) {
                  if (this.y < v9749.y + v9749.height && this.crouchVal == 0 && !this.grapple && (this.velocity.y = 0, this.onLadder = true, this.onTerrain = false, this.stepSrc = null, v9786 !== undefined)) {
                    var v9845 = (Math.abs(UTILS.getAngleDst(v9749.dir, v9786 - this.xDire)) - Math.PI / 2) / (Math.PI / 2);
                    if (v9845 > 0) {
                      this.y += config.ladderSpeed * this.config.ldA * this.weapon.spdMlt * v9774 * v9845;
                      if (this.y >= v9749.y + v9749.height) {
                        this.y = v9749.y + v9749.height;
                      }
                    }
                  }
                } else if (v9749.noPCol) {
                  ;
                } else {
                  if (v9749.ropeLadder && this.y < v9749.y + v9749.height && this.crouchVal == 0 && !this.grapple && (this.velocity.y = 0, this.onLadder = true, this.onTerrain = false, this.stepSrc = null, v9786 !== undefined)) {
                    var v9837 = UTILS.getDir(Math.sin(this.xDire), Math.cos(this.xDire), 0, 0);
                    var v9845 = (Math.abs(UTILS.getAngleDst(v9837, v9786 - this.xDire)) - Math.PI / 2) / (Math.PI / 2);
                    if (v9845 > 0) {
                      this.y += config.ladderSpeed * this.config.ldA * this.weapon.spdMlt * v9774 * v9845;
                      if (this.y >= v9749.y + v9749.height) {
                        this.y = v9749.y + v9749.height;
                      }
                    }
                  }
                  if (!v9749.ramp && v9749.collT != "cylinder" && !this.wasOnGround && !!(this.y < v9749.y + v9749.height) && !!(v9749.y + v9749.height - this.y > config.climbHeight) && !v9749.notWallJ) {
                    if (this.oldX - this.scale - (this.config ? this.config.hbS : 0) >= v9749.x + v9749.width - config.collPad) {
                      this.onWall = 1;
                    } else if (this.oldX + this.scale + (this.config ? this.config.hbS : 0) <= v9749.x - v9749.width + config.collPad) {
                      this.onWall = 2;
                    } else if (this.oldZ - this.scale - (this.config ? this.config.hbS : 0) >= v9749.z + v9749.length - config.collPad) {
                      this.onWall = 3;
                    } else if (this.oldZ + this.scale + (this.config ? this.config.hbS : 0) <= v9749.z - v9749.length + config.collPad) {
                      this.onWall = 4;
                    }
                  }
                  var v9839 = this.collides(v9749);
                  if (!v9839) {
                    continue;
                  } else if (v9749.ramp) {
                    if (this.y < v9749.y + v9749.height) {
                      var v9840 = Math.max(0, Math.min(1, UTILS.progressOnLine(v9749.ramp.sX, v9749.ramp.sZ, v9749.ramp.eX, v9749.ramp.eZ, this.x + (this.scale + (this.config ? this.config.hbS : 0)) * Math.cos(v9749.dir), this.z + (this.scale + (this.config ? this.config.hbS : 0)) * Math.sin(v9749.dir))));
                      var v9841 = v9749.y - v9749.height + (v9749.height * 2 + 0.01) * v9840;
                      if (v9825 === null) {
                        v9825 = v9841;
                      }
                      if ((this.y <= v9841 || this.wasOnGround) && v9825 <= v9841) {
                        v9825 = v9841;
                        if (v9749.boost) {
                          this.y = v9841;
                          var v9842 = v9749.boost * config.boosterSpd * v9774;
                          this.velocity.x += v9842 * Math.sin(-v9749.dir + Math.PI / 2) * Math.cos(v9749.boostDr);
                          this.velocity.z += v9842 * Math.cos(-v9749.dir + Math.PI / 2) * Math.cos(v9749.boostDr);
                          this.velocity.y += v9842 * Math.sin(v9749.boostDr);
                        } else {
                          manager.resetStep(this, recon);
                          this.y = v9841;
                          this.velocity.y = 0;
                          this.onWall = 0;
                          manager.setOnGround(this);
                          this.onTerrain = false;
                          this.stepSrc = v9749.stepSrc;
                          v9824 = true;
                          this.rampFix = v9749.y - v9749.height + v9749.height * 2 * Math.round(v9840);
                        }
                      }
                    }
                  } else if (v9749.collT == "cylinder") {
                    var v9843 = false;
                    if (this.oldY >= v9749.y + v9749.height) {
                      this.y = v9749.y + v9749.height;
                      manager.resetStep(this, recon);
                      if (!this.wasOnPad) {
                        this.velocity.y = 0;
                      }
                      manager.setOnGround(this);
                      this.onTerrain = false;
                      v9843 = true;
                    } else if (this.oldY + this.height + (this.config ? this.config.hbH : 0) <= v9749.y - v9749.height) {
                      this.y = v9749.y - v9749.height - this.height;
                      if (!this.wasOnPad) {
                        this.velocity.y = 0;
                      }
                    } else if (this.y < v9749.y + v9749.height && v9749.y + v9749.height - this.y <= config.climbHeight && this.oldY < v9749.y + v9749.height && this.wasOnGround) {
                      this.y += (v9749.y + v9749.height - this.y) * 0.3 + 0.00001;
                      manager.setOnGround(this);
                      this.onTerrain = false;
                      v9843 = true;
                    } else {
                      var v9845 = UTILS.getDir(this.x, this.z, v9749.x, v9749.z);
                      this.x = v9749.x + (v9749.width + this.scale + (this.config ? this.config.hbS : 0)) * Math.cos(v9845);
                      this.z = v9749.z + (v9749.width + this.scale + (this.config ? this.config.hbS : 0)) * Math.sin(v9845);
                      if (v9826) {
                        this.velocity.x = 0;
                        this.velocity.z = 0;
                      }
                      v9826 = true;
                    }
                    if (v9843) {
                      var v9845 = UTILS.getDir(this.x, this.z, v9749.x, v9749.z) - (v9749.spin || 0) * v9774 * config.diskSpin;
                      var v9846 = UTILS.getDistance(this.x, this.z, v9749.x, v9749.z);
                      var v9847 = this.x;
                      var v9848 = this.z;
                      this.x = v9749.x + v9846 * Math.cos(v9845);
                      this.z = v9749.z + v9846 * Math.sin(v9845);
                      this.xVelC = this.x - v9847;
                      this.zVelC = this.z - v9848;
                    }
                  } else if ((!v9749.isBorder || game.config && game.config.disableB) && this.y < v9749.y + v9749.height && v9749.y + v9749.height - this.y <= config.climbHeight && this.oldY < v9749.y + v9749.height && this.wasOnGround) {
                    this.y += v9774 * 0.03;
                    if (this.y > v9749.y + v9749.height) {
                      this.y = v9749.y + v9749.height;
                    }
                    manager.setOnGround(this);
                    this.onTerrain = false;
                  } else if (this.oldY >= v9749.y + v9749.height + (v9749.isBorder && (!game.config || !game.config.disableB) ? config.borderH : 0)) {
                    this.stepSrc = v9749.stepSrc;
                    this.y = v9749.y + v9749.height + (v9749.isBorder && (!game.config || !game.config.disableB) ? config.borderH : 0);
                    manager.resetStep(this, recon);
                    if (!this.wasOnPad) {
                      this.velocity.y = 0;
                    }
                    manager.setOnGround(this);
                    this.onTerrain = false;
                  } else if (this.oldX - this.scale - (this.config ? this.config.hbS : 0) >= v9749.x + v9749.width - 0.00001) {
                    this.x = v9749.x + v9749.width + this.scale + (this.config ? this.config.hbS : 0);
                    this.velocity.x = 0;
                  } else if (this.oldX + this.scale + (this.config ? this.config.hbS : 0) <= v9749.x - v9749.width + 0.00001) {
                    this.x = v9749.x - v9749.width - this.scale - (this.config ? this.config.hbS : 0);
                    this.velocity.x = 0;
                  } else if (this.oldZ - this.scale - (this.config ? this.config.hbS : 0) >= v9749.z + v9749.length - 0.00001) {
                    this.z = v9749.z + v9749.length + this.scale + (this.config ? this.config.hbS : 0);
                    this.velocity.z = 0;
                  } else if (this.oldZ + this.scale + (this.config ? this.config.hbS : 0) <= v9749.z - v9749.length + 0.00001) {
                    this.z = v9749.z - v9749.length - this.scale - (this.config ? this.config.hbS : 0);
                    this.velocity.z = 0;
                  } else if (this.oldY + this.height + (this.config ? this.config.hbH : 0) <= v9749.y - v9749.height) {
                    this.stopCrouch = true;
                    this.y = v9749.y - v9749.height - (this.wasStopCrouch && game.config.headClipFix ? this.heightOld : this.height) - (this.config ? this.config.hbS : 0);
                    if (!this.wasOnPad) {
                      this.velocity.y = 0;
                    }
                  } else if (game.config.headClipFix && this.oldY + this.heightOld + (this.config ? this.config.hbH : 0) <= v9749.y - v9749.height) {
                    this.stopCrouch = true;
                    this.y = v9749.y - v9749.height - this.height - (this.config ? this.config.hbS : 0);
                    if (!this.wasOnPad) {
                      this.velocity.y = 0;
                    }
                  }
                }
              }
            }
          }
          var vA545 = [];
          for (var vLN01583 = 0; vLN01583 < this.collidingObjs.length; vLN01583++) {
            if (vA541.indexOf(this.collidingObjs[vLN01583]) == -1) {
              vA545.push(this.collidingObjs[vLN01583]);
            }
          }
          var v9849;
          for (var vLN01583 = 0; vLN01583 < vA545.length; vLN01583++) {
            v9849 = this.collidingObjs.indexOf(vA545[vLN01583]);
            if (v9849 > -1) {
              this.collidingObjs.splice(v9849, 1);
            }
            game.objectTrigger("onExitObject", vA545[vLN01583], this);
          }
          if (game.mode && game.mode.site) {
            for (var vLN01583 = 0; vLN01583 < game.map.manager.sites.length; ++vLN01583) {
              v9749 = game.map.manager.sites[vLN01583];
              if (!recon && this.collides(v9749)) {
                if (this.team == 2 && this.weapon && this.weapon.bomb) {
                  if (v9777 && this.onGround) {
                    this.doingInter = true;
                    this.interTick -= v9774;
                    if (this.isYou && this.interTick <= 0) {
                      this.interTick = 400;
                      SOUND.play("beep_0", 0.1, false, UTILS.randFloat(0.95, 1));
                    }
                    this.interProg += v9774 / 2000;
                    this.makingProg = true;
                    if (this.interProg >= 1) {
                      this.interProg = 1;
                      game.plantBomb(this, v9749);
                    }
                  } else {
                    manager.changeInteract(this, v9749, 3, 1, 1);
                  }
                } else if (this.team == 2 && this.loadout.indexOf(17) > -1) {
                  manager.changeInteract(this, v9749, 3, 2, 1);
                }
              }
            }
          }
          this.onZone = null;
          if (game.mode && game.mode.collisionCheck) {
            game.mode.collisionCheck(game, this, recon);
          }
          if (!game.mode || !game.mode.noPickups) {
            for (var vLN01583 = 0; vLN01583 < game.map.manager.pickups.length; ++vLN01583) {
              v9749 = game.map.manager.pickups[vLN01583];
              if (this.collides(v9749) && UTILS.isNumber(v9749.pickup) && (!game.mode.teamOptions || game.mode.teamOptions[this.team - 1] != "Infected")) {
                if (v9749.active && game.teamCheck(v9749, this) && (!game.weaponConfig[v9749.pickup].bomb || game.mode && game.mode.site)) {
                  manager.changeInteract(this, v9749, 6);
                } else if (!v9749.active && this.team == 1 && game.weaponConfig[v9749.pickup].bomb && game.mode && game.mode.site) {
                  if (v9777 && this.onGround) {
                    this.doingInter = true;
                    this.interProg += v9774 / 4000;
                    this.makingProg = true;
                    if (this.interProg >= 1) {
                      this.interProg = 1;
                      game.diffuseBomb(this);
                    }
                  } else {
                    manager.changeInteract(this, v9749, 3, 3, 1);
                  }
                }
              }
            }
          }
          for (var vLN01583 = 0; vLN01583 < game.airDrop.drops.length; ++vLN01583) {
            v9749 = game.airDrop.drops[vLN01583];
            if (v9749.canClaim && this.collides(v9749, v9749.claimRadius) && (manager.changeInteract(this, v9749, 10, null, 1), v9783 && this.onGround)) {
              this.makingProg = true;
              this.interProg += v9774 / v9749.claimTime;
              if (this.interProg >= 1) {
                this.interProg = 0;
                game.claimAirDrop(this, v9749);
              }
              break;
            }
          }
        }
        if (!this.noclip) {
          if (game.mode && (game.mode.flags || game.mode.oneflag)) {
            for (var vLN01583 = 0; vLN01583 < game.map.manager.flags.length; ++vLN01583) {
              v9749 = game.map.manager.flags[vLN01583];
              if (v9749.active && this.collides(v9749) && v9749.flag) {
                game.pickupFlag(this, v9749);
              }
            }
          }
          for (var v9850 in game.map.manager.spawnables) {
            v9749 = game.map.manager.spawnables[v9850];
            if (v9749.active && !v9749.ai && this.collides(v9749)) {
              var v9851 = game.pickupSpawnable(this, v9749);
              if (v9851) {
                manager.changeInteract(this, v9749, 12, v9851, 1);
              }
            }
          }
          for (var vLN01583 = 0; vLN01583 < game.map.manager.spinners.length; ++vLN01583) {
            v9749 = game.map.manager.spinners[vLN01583];
            if (this.collides(v9749, v9749.tRadius || 0)) {
              manager.changeInteract(this, v9749, 9);
            }
          }
        }
        if (this.grapple) {
          var v9852 = UTILS.getD3D(this.x, this.y, this.z, this.grapple.x, this.grapple.y, this.grapple.z);
          var v9853 = v9852 - this.grapple.range;
          if (v9853 >= 0.2) {
            manager.endGrapple(this);
          }
        }
        if (!this.didJump && this.rampFix != null && Math.abs(this.y - this.rampFix) <= config.climbHeight) {
          if (!v9824) {
            this.y = this.rampFix;
            manager.setOnGround(this);
            this.velocity.y = 0;
            this.rampFix = null;
          }
        } else {
          this.rampFix = null;
        }
        if (!this.makingProg && !recon) {
          this.interProg = 0;
        }
        if (!this.makingMProg && !recon) {
          this.interMProg = 0;
        }
        var v9854 = game.map.terrain;
        if (v9854 && !this.noclip) {
          var v9855 = v9854.raycast(this.x, -this.z, 10000, 0, 0, -20000, true);
          if (v9855) {
            var v9856 = v9855.z;
            if (this.y <= v9856) {
              manager.resetStep(this, recon);
              this.onTerrain = true;
            }
            if (this.onTerrain) {
              manager.setOnGround(this);
              var v9857 = v9854._raycastNormal;
              v9857.set(v9857.x, v9857.z, -v9857.y);
              this.y = v9856;
              this.velocity.y = 0;
              this.jumpCooldown = 0;
            }
          }
        }
        if (this.onGround) {
          this.airTime = 0;
        } else {
          this.airTime += v9774;
        }
      }
      this.coverDis += UTILS.getDistance(this.oldX, this.oldZ, this.x, this.z);
      if (!recon && (!game.mode.teamOptions || game.mode.teamOptions[this.team - 1] != "Prop") && (!this.config || this.config.mdl !== 1)) {
        var v9858 = UTILS.getD3D(this.oldX, this.oldY, this.oldZ, this.x, this.y, this.z);
        if (this.renderYou) {
          if (this.onLadder) {
            v9858 *= 1.4;
          }
          this.bobAnimZ += UTILS.getDistance(this.oldX, this.oldZ, this.x, this.z) * config.bobMltZ;
          this.bobAnimY -= (this.oldY - this.y) * config.bobMltY;
        }
        if (v9804 && v9858 && v9858 >= 0.1) {
          manager.playerStep(this, v9858);
        }
        if (this.renderYou) {
          if (v9804 && v9786 !== undefined) {
            this.leanAnimZ -= v9858 * config.leanMltZ * (this.weapon.zLnM || 1) * Math.cos(v9786);
          } else {
            this.stepVal *= Math.pow(config.stepPull, v9774);
          }
        }
        if (this.stepChase != this.stepVal) {
          this.stepChase += (this.stepVal - this.stepChase) * 0.15;
        }
        this.spreadPlus += (v9858 * config.spreadMove + Math.abs(this.oldY - this.y) * config.spreadFall) * (this.weapon.movSpread || 0);
        this.spreadPlus *= Math.pow(config.spreadRecover, v9774);
        this.spread = this.weapon.noSpread ? 0 : Math.max(this.weapon.minSpread || 0, (this.weapon.spread - this.weapon.spread * config.crouchSpread * this.crouchVal + (this.noRecoil ? 0 : this.recoilAnim * config.spreadMlt) + this.spreadPlus) * (this.aimVal + (1 - this.aimVal) * this.weapon.adSpread));
        if (this.resetTimer > 0) {
          this.resetTimer -= v9774;
          if (this.resetTimer <= 0) {
            this.resetTimer = 0;
          }
        }
        var v9859 = !game.mode || !game.mode.noReloads;
        if (game.mode && game.mode.finiteAmmo && !this.isBot && this.ammos[this.loadoutIndex] <= 0 && this.reserveAmmos[this.loadoutIndex] <= 0) {
          v9859 = false;
        }
        if (v9780 && v9859) {
          manager.reload(this);
        }
        if (this.reloadTimer > 0) {
          var v9860 = this.reloadTimer;
          this.reloadTimer -= v9774;
          manager.reloadUIAnim(this);
          var v9861 = this.reloadTimer / (this.weapon.reload * (game.config.reSpd || 1) * this.attributes.reload * (this.perks.includes(2) ? 0.5 : 1) * (this.isKranked ? game.mode.bonuses.reload : 1) * (game.mode && game.mode.reloadMlt != null ? game.mode.reloadMlt : 1));
          if (this.isYou && v9860 >= v9861 / 2 && this.reloadTimer < v9861 / 2) {
            manager.endReload(this);
          }
          if (this.reloadTimer <= 0) {
            this.reloadTimer = 0;
            this.didShoot = false;
            if (game.mode && game.mode.finiteAmmo && !this.isBot) {
              var v9862 = game.mode && game.mode.ammoLimit != null ? game.mode.ammoLimit : this.weapon.ammo;
              var vLN01581 = 0;
              var v9863 = this.reserveAmmos[this.loadoutIndex];
              v9863 += this.ammos[this.loadoutIndex];
              v9863 -= v9862;
              if (v9863 < 0) {
                vLN01581 = v9862 + v9863;
                v9863 = 0;
              } else {
                vLN01581 = v9862;
              }
              this.reserveAmmos[this.loadoutIndex] = v9863;
              this.ammos[this.loadoutIndex] = vLN01581;
            } else {
              this.ammos[this.loadoutIndex] = game.mode && game.mode.ammoLimit != null ? game.mode.ammoLimit : this.weapon.ammo;
            }
            manager.updatePlayerAmmo(this);
            manager.resetReloadUIAnim(this);
          }
        }
        if (this.cantShootTimer > 0) {
          this.cantShootTimer -= v9774;
          if (this.cantShootTimer <= 0) {
            this.cantShootTimer = 0;
          }
        }
        if (this.buildHelper && (!this.weapon.build || this.reloads[this.loadoutIndex] || this.selectBuild)) {
          this.buildHelper.visible = false;
          this.buildHelperN.visible = false;
        }
        if (this.swapTime > 0) {
          this.swapTime -= v9774;
          if (this.swapTime < 0) {
            this.swapTime = 0;
          }
        }
        for (var vLN01583 = 0; vLN01583 < this.reloads.length; ++vLN01583) {
          if (this.reloads[vLN01583] > 0) {
            this.reloads[vLN01583] -= v9774;
            if (this.reloads[vLN01583] < 0) {
              this.reloads[vLN01583] = 0;
            }
          }
        }
        if (this.weapon && !lock && !this.doingInter) {
          if (!this.onGround && !this.config.airSh) {
            this.didShoot = false;
          }
          var v9864 = this.burstCount || !this.weapon.nAuto && v9777;
          if (this.didShoot && !v9777) {
            this.didShoot = false;
          }
          if (!this.didShoot && v9777) {
            v9864 = true;
          }
          if (this.reloads[this.loadoutIndex] <= 0 && this.swapTime <= 0 && this.reloadTimer <= 0) {
            if (this.weapon.grapRang) {
              manager.tryGrapple(this, this.weapon.grapRang, v9864, input);
            } else if (this.weapon.build) {
              manager.build(this, v9864);
            } else if (v9864 && (!this.crouchVal || this.crouchVal && this.config.croSh) && (this.config.airSh || this.onGround && !this.config.airSh) && (this.config.hipF || this.aimVal != 1 && !this.config.hipF)) {
              this.noMovTimer = 0;
              if (this.weapon.melee) {
                manager.melee(this, input);
              } else {
                var vParseInt28 = parseInt(this.weapon.id);
                if (this.ammos[this.loadoutIndex] > 0) {
                  if (this.fullCharge) {
                    manager.shoot(this, input, vParseInt28, v9776, v9775, true);
                  } else {
                    manager.shoot(this, input, vParseInt28, v9776, v9775);
                  }
                } else if (v9859) {
                  manager.reload(this);
                } else {
                  manager.cantShoot(this);
                }
              }
            }
          }
        }
      }
      if (!lock && recon) {
        if (input.velObj) {
          this.velocity.x -= input.velObj.x;
          this.velocity.z -= input.velObj.y;
          if (!this.noclip) {
            this.velocity.y -= input.velObj.z;
          }
          this.onGround = false;
        }
        if (input.grapObj) {
          this.grapple = {
            x: input.grapObj.x,
            y: input.grapObj.y,
            z: input.grapObj.z,
            range: input.grapObj.r
          };
        }
      }
      if (!v9773.noWallJ && this.wallJump && this.wallJumpC < this.wallJumpMax && !this.onGround && !this.onLadder && this.onWall && v9809 > 0 && !lock && (this.didJumpW && !v9779 && (this.didJumpW = false), !this.didJumpW && v9779)) {
        this.didJumpW = true;
        this.wallJumpC++;
        if (!recon && this.isYou) {
          if (this.jumpTween) {
            this.jumpTween.stop();
          }
          this.jumpTween = new TWEEN.Tween(this).to({
            jumpBobY: 0.26
          }, 500).easing(TWEEN.Easing.Back.Out).start();
          new TWEEN.Tween(this).to({
            jumpRot: [0.15, 0]
          }, 900).easing(TWEEN.Easing.Back.Out).start();
          SOUND.play(game.players.getJumpSound(this), 0.04, false);
        }
        var v9865 = (game.mode.wallJV == null ? this.config.wallJV || 0 : game.mode.wallJV) * (game.mode.realMov ? 0.7 : 1);
        this.velocity.y = (game.mode.realMov ? 0.9 : 1) * 0.058 * (game.mode.wallJYV == null ? 1 : game.mode.wallJYV);
        if (this.onWall == 1) {
          this.velocity.x = v9865 * v9809;
        } else if (this.onWall == 2) {
          this.velocity.x = -v9865 * v9809;
        } else if (this.onWall == 3) {
          this.velocity.z = v9865 * v9809;
        } else if (this.onWall == 4) {
          this.velocity.z = -v9865 * v9809;
        }
        this.onWall = 0;
      }
      if (!lock && game.mode.canTrade && !game.waitTimers) {
        var v9866 = this.x;
        var v9867 = this.y;
        var v9868 = this.z;
        if (game.now - 0 >= 500) {
          for (var vLN01583 = 0; vLN01583 < game.players.list.length; ++vLN01583) {
            v9749 = game.players.list[vLN01583];
            if (this.active && v9749.active && !v9749.isYou && v9749.level) {
              var v9869 = config.playerHeight / 2;
              var v9870 = UTILS.getD3D(v9866, v9867 + v9869, v9868, v9749.x, v9749.y + v9869, v9749.z);
              if (v9870 <= v9869 * 2.4) {
                manager.changeInteract(this, v9749, 5, null, 1);
              }
            }
          }
        }
      }
      if (!lock) {
        manager.playerConvTeam(this);
        manager.updateInteract(this);
      }
      if (v9782 != 2 || !this.active || this.resetTimer || recon) {
        if (v9782 && this.active && !this.resetTimer && !recon) {
          manager.resetToStart(this);
        }
      } else {
        manager.resetToLast(this);
      }
    }
  };
  this.send = function () {
    if (game && game.send) {
      game.send(this.id, ...arguments);
    }
  };
}
module.exports = Player;